import React from 'react';
import '@/styles/HomeStyle.css';
import Logo from '@UI/Logo';
import BackToWebviewButton from '@components/common/BackToWebViewButton/BackToWebviewButton';

function TopMenu({ logo }) {
  return (
    <div className="upMenu">
      {logo ? (
        <img
          alt="Logo"
          src={logo}
          style={{
            height: 'auto',
            width: 'auto',
            display: 'flex',
            maxHeight: 25,
          }}
        />
      ) : (
        <Logo className="logoHeader" />
      )}
      <BackToWebviewButton />
    </div>
  );
}

export default TopMenu;
